import { RelationshipProperty } from "../../property-types";
import {
  DynamicFilter,
  DynamicFilterOperator,
  DynamicFilterOpts,
} from "../DynamicFilter";

export class RelationshipManyFilter extends DynamicFilter {
  public operatorLabelsMap = {
    equals: "includes",
    notEquals: "does not include",
    isNotNull: "has any",
  };

  public disabledOperators: DynamicFilterOperator[] = [
    "lessThan",
    "greaterThan",
    "lessThanOrEqual",
    "greaterThanOrEqual",
    "contains",
    "notContains",
  ];

  constructor(opts: DynamicFilterOpts) {
    super(opts);

    if (!this.property.isHydrated) {
    }
  }

  public getValueAsync(): Promise<any> {
    return (this.property as RelationshipProperty).hydrate().then(() => {
      return this.value;
    });
  }
}
